module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-solid-rounded-N5CQNTC6.eot?ebf71074e49f1cc4e8603b52feeeac5a";